import App from 'app/app.js';
import 'app/store/ContentStore.js';
import 'app/action/ContentChangeAction.js';

// lt-translate-src="RESOURCE_KEY", Optional: lt-zone="ZONE_KEY", Optional: lt-default-look-layout="true", Optional: lt-use-cdn="true"
function LtTranslateSrcDirective(ContentStore, ContentChangeAction, VisualMerchandiseStore) {
  return {
    restrict: 'A',
    replace: true,
    scope: true,
    // expects a translation key
    link: function linkFn(scope, element, attrs) {
      var unbinders;
      var applyElementContent = function (translationKey, useDefaultLookLayoutId) {
        var content, altText;
        // try to get content with layout theme id appended
        if (useDefaultLookLayoutId) {
          var vm = VisualMerchandiseStore.getVisualMerchandise();
          var defaultLayoutThemeId = !!vm && !!vm.defaultLook ? vm.defaultLook.layoutThemeID : '';
          if (!!defaultLayoutThemeId) {
            var key = translationKey + '_' + defaultLayoutThemeId;
            content = ContentStore.getContent(scope.zone || null, key);
            altText = ContentStore.getContent(scope.zone || null, key + '_ALT');
          }
        }

        // otherwise get by key alone
        if (!content) {
          content = ContentStore.getContent(scope.zone || null, translationKey);
          altText = ContentStore.getContent(scope.zone || null, translationKey + '_ALT');
        }

        if (!!content) {
          element[0].src = ContentStore.resolveContentImagePath(content);

          // Override content src with CDN src if available
          if (window.cdnImages) {
            var cdnImages = window.cdnImages;
            Object.keys(cdnImages).forEach(function (img) {
              if (content.includes(img)) {
                element[0].src = cdnImages[img];
              }
            });
          }

          if (!!altText) {
            element[0].alt = altText;
          }
        }
      };
      var updateTranslationFn = function () {
        var unwatch = scope.$watch(
          'translationKey',
          function () {
            if (!!scope.translationKey) {
              applyElementContent(scope.translationKey, scope.useDefaultLookLayoutId);
              unwatch();
            }
          },
          false
        );
      };

      unbinders = [ContentChangeAction.register(updateTranslationFn)];

      updateTranslationFn();

      unbinders.push(
        attrs.$observe('ltTranslateSrc', function (translationKey) {
          if (translationKey.endsWith('_$COUNTRY')) {
            translationKey = ContentStore.appendCountryCode(translationKey.replace('_$COUNTRY', ''));
          }
          scope.translationKey = translationKey;
        })
      );

      unbinders.push(
        attrs.$observe('ltZone', function (zone) {
          scope.zone = zone;
          updateTranslationFn();
        })
      );

      unbinders.push(
        attrs.$observe('ltDefaultLookLayout', function (useDefaultLookLayoutId) {
          scope.useDefaultLookLayoutId = useDefaultLookLayoutId;
        })
      );

      scope.$on(
        '$destroy',
        function () {
          unbinders.forEach(function (unbinder) {
            unbinder();
          });
        }.bind(this)
      );
    }
  };
}

App.directive('ltTranslateSrc', [
  'ContentStore',
  'ContentChangeAction',
  'VisualMerchandiseStore',
  LtTranslateSrcDirective
]);
